import React from "react";
import useAxios from "../../Hooks/useAxios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
  Typography
} from "@mui/material";

import { AxiosService } from "../../Services/AxiosService";
import { useAuth } from "react-oidc-context";

function PermissionsModal({ open, onClose, file, onSaved }) {
  const auth = useAuth();
  const token = auth.user?.access_token;

  const [departments, setDepartments] = React.useState([]);
  const [selected, setSelected] = React.useState([]);

  const { data: departmentsData, isLoading } = useAxios("departments");

  /**
   * Load departments into local state
   */
  React.useEffect(() => {
    if (departmentsData) {
      setDepartments(departmentsData);
    }
  }, [departmentsData]);

  /**
   * Initialize selected permissions when file changes
   */
  React.useEffect(() => {
    if (file?.permissions) {
      setSelected(file.permissions);
    } else {
      setSelected(["MANAGER"]); // default rule
    }
  }, [file]);

  /**
   * Toggle department selection
   */
  const toggle = (dept) => {
    if (dept === "MANAGER") return; // locked always

    setSelected(prev =>
      prev.includes(dept)
        ? prev.filter(d => d !== dept)
        : [...prev, dept]
    );
  };

  /**
   * Save permissions to backend
   */
  const handleSave = async () => {
    try {
      if (!file?.id) {
        console.error("Missing file id");
        return;
      }

      await AxiosService.update_file_permissions(
        token,
        file.id,
        selected
      );

      onSaved?.();
      onClose?.();

    } catch (err) {
      console.error("Error saving permissions", err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>File Permissions</DialogTitle>

      <DialogContent>
        {isLoading ? (
          <Typography>Loading departments...</Typography>
        ) : departments.length === 0 ? (
          <Typography>No departments found</Typography>
        ) : (
          <Box>
            {departments.map(dept => (
              <FormControlLabel
                key={dept.name}
                control={
                  <Checkbox
                    checked={selected.includes(dept.name)}
                    onChange={() => toggle(dept.name)}
                    disabled={dept.name === "MANAGER"}
                  />
                }
                label={dept.name}
              />
            ))}
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSave}
          disabled={isLoading || departments.length === 0}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PermissionsModal;